const isPropertyKey = (value) =>
  typeof value === 'string' || typeof value === 'number' || typeof value === 'symbol';

const isIndexKey = (value) => isPropertyKey(value) || value === null;

const getValueByPath = (item, key) => {
  if (typeof key !== 'string' || !key.includes('.')) {
    return item?.[key];
  }

  return key.split('.').reduce((acc, part) => {
    if (acc === null || acc === undefined || typeof acc !== 'object') {
      return undefined;
    }

    return acc[part];
  }, item);
};

/**
 * @template T
 * @param {T[]} arr
 * @param {keyof T | string} key
 * @param {{ type?: 'unique' | 'group', iterateCallback?: (item: T, index: number) => void }} [options]
 * @returns {Record<PropertyKey, T> | Record<PropertyKey, T[]>}
 */
export function indexedArray(arr, key, options) {
  if (options?.type === 'group') {
    return arr.reduce((acc, cur, index) => {
      if (options?.iterateCallback) {
        options.iterateCallback(cur, index);
      }

      const keyValue = getValueByPath(cur, key);
      if (isIndexKey(keyValue)) {
        if (!acc[keyValue]) {
          acc[keyValue] = [];
        }

        acc[keyValue].push(cur);
      }

      return acc;
    }, {});
  }

  return arr.reduce((acc, cur, index) => {
    if (options?.iterateCallback) {
      options.iterateCallback(cur, index);
    }

    const keyValue = getValueByPath(cur, key);
    if (isIndexKey(keyValue)) {
      acc[keyValue] = cur;
    }

    return acc;
  }, {});
}
